import { createFileRoute, redirect } from '@tanstack/react-router'
/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

export const Route = createFileRoute('/')({
  loader: () => {
    throw redirect({to: "/projects"});
  }
})